// Profiles/{uid} = { displayName }: the only account data visible to other users.
// Written at sign-up, refreshed at sign-in, and whenever the name changes in Settings.

export async function ensureProfile(db, user, name) {
  if (!user || !user.uid) return;
  const displayName = String(name || user.displayName || "").trim().slice(0, 80);
  await db.collection("Profiles").doc(user.uid).set({ displayName });
}

/** Display names for a list of uids; missing profiles come back as "". */
export async function getDisplayNames(db, uids) {
  const docs = await Promise.all(
    uids.map((id) => db.collection("Profiles").doc(id).get().catch(() => null))
  );
  const names = {};
  docs.forEach((doc, i) => {
    const d = doc && doc.exists ? doc.data() : null;
    names[uids[i]] = d && typeof d.displayName === "string" ? d.displayName : "";
  });
  return names;
}
